import dayjs from 'dayjs';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { SearchRangePicker } from 'components/search';
import { DateRangeFilter } from '@cast/shared-date-ui';

import { RangePickerCriterion } from '@cast/shared-search-ui';

const getRangeCriteria = (
  defaultPreset: DateRangeFilter
): RangePickerCriterion => ({
  key: 'dateRange',
  initialValue: {
    preset: defaultPreset,
    timezone: dayjs.tz.guess(),
  },
});

type DateRangeSelectProps = {
  defaultFilterPreset: DateRangeFilter;
  filterPresets: DateRangeFilter[];
  allowTimeInput?: boolean;
};

export const DateRangeSelect = ({
  defaultFilterPreset,
  filterPresets,
  allowTimeInput = true,
}: DateRangeSelectProps) => {
  const isClusterDemoMode = useIsClusterDemoMode();

  return (
    <SearchRangePicker
      criteria={getRangeCriteria(defaultFilterPreset)}
      initialPreset={defaultFilterPreset}
      filterPresets={filterPresets}
      triggerInputProps={{
        size: 'medium',
        sx: {
          minWidth: 'auto',
        },
      }}
      initialTimezone={isClusterDemoMode ? 'UTC' : undefined}
      allowTimeInput={allowTimeInput}
      maxNumberOfDays={365}
    />
  );
};
